import { Heart } from 'lucide-react'
import { SeriesChart, VitalChartFrame, vitalNumber } from '../VitalPlot/VitalPlot'
import '../VitalPlot/VitalPlot.css'
import './HeartRateChart.css'

function formatRate(value) {
  if (!Number.isFinite(value)) return '—'
  return `${Math.round(value)} bpm`
}

function HeartRateChart({ points = [] }) {
  const series = points
    .map((point) => ({ at: point.at, value: vitalNumber(point.heartRate) }))
    .filter((point) => point.value != null)
    .map((point) => ({
      at: point.at,
      value: point.value,
      label: `${Math.round(point.value)}`
    }))
  const latest = series.length ? series[series.length - 1].value : null
  const values = series.map((point) => point.value)
  const dataMin = values.length ? Math.min(...values) : 60
  const dataMax = values.length ? Math.max(...values) : 100
  const yMin = Math.min(40, Math.floor(dataMin / 20) * 20)
  const yMax = Math.max(140, Math.ceil(Math.max(dataMax, 100) / 20) * 20)
  const ticks = []
  for (let tick = yMin; tick <= yMax; tick += 20) ticks.push(tick)

  return (
    <VitalChartFrame
      className="heart-rate-chart"
      icon={<Heart size={16} />}
      title="Frequência Cardíaca (bpm)"
      badgeLabel="FC Atual:"
      badgeValue={formatRate(latest)}
      legend={[
        { mark: 'is-low', label: 'Bradicardia (≤ 60 bpm)' },
        { mark: 'is-alert', label: 'Taquicardia (≥ 100 bpm)' },
        { mark: 'is-safe', label: 'Faixa de repouso (60 - 100 bpm)' }
      ]}
      empty={series.length === 0 ? 'Nenhuma frequência cardíaca registrada para este paciente.' : ''}
    >
      <SeriesChart
        points={series}
        yMin={yMin}
        yMax={yMax}
        ticks={ticks}
        tickLabel={(tick) => `${tick}`}
        band={{ from: 60, to: 100 }}
        guides={[
          { key: 'brady', value: 60, className: 'vital-guide-low' },
          { key: 'tachy', value: 100, className: 'vital-guide-alert' }
        ]}
        gradientFrom="#db2777"
        gradientTo="#fbcfe8"
        ariaLabel="Frequência cardíaca"
      />
    </VitalChartFrame>
  )
}

export default HeartRateChart
